import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  makeStyles,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";

import Modal from "react-modal";
import RestaurantInfo from "./RestaurantInfo";
import styles from "./styles.module.css";
import { Auth } from "aws-amplify";
import { AuthContext } from "../../Context/Auth";
import { Instance } from "../../Context/axiosContext";
import { Link } from "react-router-dom";
import { ApiContext } from "../../Context/ApiKey";
import axios from "axios";
const useStyles = makeStyles({
  img: {
    width: "100%",
    height: "100vh",
    backgroundSize: "cover",
  },
  form: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  input: {
    marginTop: "30px",
    width: "50%",
  },
  button: {
    marginTop: "30px",
    color: "white",
    fontWeight: "500",
    height: "50px",
    fontSize: "20px",
  },

  linkDiv: {
    fontSize: "12px",
    width: "10%",
    marginLeft: "6rem",
  },
  adminCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  para: {
    fontWeight: "lighter",
    fontSize: "22px",
  },
  link: {
    cursor: "pointer",
    float: "right",
  },
  heading: {
    marginTop: "70px",
    textAlign: "center",
    fontSize: "40px",
  },
  textBox: {
    marginTop: "50px",
    paddingTop: "20px",
    fontSize: "40px",
    height: "40vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "100vh",
    // padding: 0px 20px;
    backgroundColor: "#d3d3d3",
    overflowY: "scroll",
    padding: "20px",
  },
  dflex: {
    height: "100%",
    display: "flex",
    padding: "25px",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  restName: {
    fontSize: "24px !important",
  },
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "& .MuiTypography-body1": {
      fontSize: "24px",
      fontWeight: "lighter",
      textAlign: "start",
    },
  },
});
const MultiRestLogin = ({ history }) => {
  const classes = useStyles();
  const { login } = useContext(AuthContext);
  const { SetApikey } = useContext(ApiContext);
  const [restData, setRestData] = useState([]);
  const [restId, setRestId] = useState("");
  const axiosInstance = Instance();
  const [value, setValue] = useState("");
  const handleRadioChange = (event) => {
    setValue(event.target.value);
  };
  // const email = localStorage.get(
  //     "CognitoIdentityServiceProvider.222t368vpog9tjbrisfbjqf82e.2a620c04-ce69-476b-a0e9-3ba911d07edf.userData"
  // );
  // console.log("history", email);
  const handleSubmit = (event) => {
    event.preventDefault();
    if (value === "") {
      return;
    }
    const restaurant = restData[parseInt(value)];
    localStorage.setItem("apikey", restaurant.api_key);
    SetApikey(restaurant.api_key);
    console.log(restaurant);
    login(idToken);
    history.push("/");
  };
  const [idToken, setIdToken] = useState();
  const checkIfMultipleRestrauntOwner = async (idToken) => {
    try {
      const { data } = await axios.get(
        process.env.REACT_APP_API_URL + `restaurant/multi/switch`,
        {
          headers: {
            Authorization: idToken,
          },
        }
      );
      // const data = await res.json();
      setRestData(data.restaurants);

      // if (data.multiple === true) {
      //   history.push("/multiLogin");
      //   if(restId){
      //     login(idToken)
      //     history.push("/")
      //   }
      // }
    } catch (err) {
      console.log("err****", err);
    }
  };

  //Checking if user is already logged in or not
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    Auth.currentSession()
      .then((data) => {
        if (data) {
          console.log("get", data);
          let idToken = data.getIdToken().getJwtToken();
          if (data.getIdToken().payload["custom:Role"] === "RestAdmin") {
            localStorage.setItem(
              "COgnitoRole",
              data.getIdToken().payload["custom:Role"]
            );
          } else {
            const Distr = JSON.parse(
              data.getIdToken().payload["custom:rest"]
            ).customClaimValue;
            localStorage.setItem("COgnitoRole", JSON.stringify(Distr));
          }
          setIdToken(idToken);
          checkIfMultipleRestrauntOwner(idToken);
          // history.push(inMemRoute);
        }
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {restData && (
        <Grid container>
          <Grid item sm={12} xs={12} md={6} lg={6}>
            <form onSubmit={handleSubmit} className={classes.dflex}>
              <FormControl component="fieldset">
                <Typography className={classes.heading}>
                  Multi Restaurant Login
                </Typography>
                <RadioGroup
                  aria-label="restaurant select"
                  name="radio-buttons-group"
                  onChange={handleRadioChange}
                >
                  <div className={classes.textBox}>
                    {restData.map((restaurant, index) => {
                      return (
                        <FormControlLabel
                          className={classes.root}
                          value={index.toString()}
                          control={
                            <Radio
                              color="primary"
                              className={classes.restName}
                            />
                          }
                          label={restaurant.name}
                        />
                      );
                    })}
                  </div>
                </RadioGroup>
                <Button
                  className={classes.button}
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="medium"
                  fullWidth
                  data-testid="loginBtn"
                >
                  Login
                </Button>
                <Button
                  className={classes.button}
                  variant="contained"
                  color="secondary"
                  size="medium"
                  href="/login"
                  fullWidth
                  onClick={() => {
                    localStorage.clear();
                  }}
                >
                  Go Back
                </Button>
              </FormControl>
            </form>
          </Grid>
          <Grid item lg={6} md={6}>
            <Box display={{ xs: "none", md: "block", lg: "block" }}>
              <img
                className={classes.img}
                src="https://images.unsplash.com/photo-1616277434251-0e5188ccbe00?ixid=MXwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                alt="images"
              />
            </Box>
          </Grid>
        </Grid>
        // <Grid container style={{ height: "100vh" }}>
        //     <Grid item sm={12} className={classes.restautants}>
        //         <Typography
        //             style={{
        //                 fontSize: "40px",
        //                 marginTop: "60px",
        //             }}
        //         >
        //             Multi Restaurant Login
        //         </Typography>
        //         <Box className={classes.restContainer}>
        //             <div
        //                 style={{
        //                     width: "100%",
        //                     display: "flex",
        //                     flexDirection: "column",
        //                     alignItems: "center",
        //                     justifyContent: "center",
        //                 }}
        //             >
        //                 {restData.map((restaurant) => {
        //                     return (
        //                         <RestaurantInfo
        //                             idToken={idToken}
        //                             restaurant={restaurant}
        //                         />
        //                     );
        //                 })}
        //             </div>
        //         </Box>
        //         <Button
        //             color="primary"
        //             onClick={() => history.push("/login")}
        //             variant="outlined"
        //             size="large"
        //         >
        //             Go Back
        //         </Button>
        //     </Grid>
        // </Grid>
      )}
    </>
  );
};

export default MultiRestLogin;
